<template>
  <div class="model-generator-history">
    <div class="history-header">
      <h4>Job History</h4>
      <span v-if="loading" class="loading-indicator">Loading...</span>
    </div>

    <div v-if="loading && jobs.length === 0" class="no-jobs">
      <p>Loading jobs...</p>
    </div>

    <div v-else-if="jobs.length === 0" class="no-jobs">
      <p>No jobs yet</p>
    </div>

    <div v-else class="job-list">
      <div
        v-for="job in displayedJobs"
        :key="job.Id"
        :class="['job-item', { active: job.Id === selectedJobId }]"
        @click="$emit('select-job', job.Id)"
      >
        <div class="job-header">
          <div class="job-title">
            <span class="job-name">{{ job.Id }}</span>
          </div>
          <div class="job-right">
            <span v-if="job.Status === 'Processing'" class="job-progress">
              <span class="progress-text">{{ job.Progress }}%</span>
            </span>
            <span :class="['job-status', `status-${job.Status.toLowerCase()}`]">
              {{ job.Status }}
            </span>
          </div>
        </div>

        <div class="job-meta">
          <div class="job-info-row">
            <div class="job-date">
              {{ formatDate(job.CreatedAt) }}
            </div>
            <div class="job-product">
              {{ job.ProductName }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <button v-if="hasMore" class="btn btn-link show-more-btn" @click="loadMore">
      Show more
    </button>
  </div>
</template>

<script>
export default {
  name: 'ModelGeneratorHistory',
  props: {
    jobs: {
      type: Array,
      default: () => []
    },
    selectedJobId: {
      type: [String, Number],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    displayedJobs() {
      return this.jobs
    },
    hasMore() {
      return this.jobs.length < this.totalCount
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },
    loadMore() {
      this.$emit('load-more')
    }
  }
}
</script>

<style scoped lang="scss">
.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;

  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 0;
  }

  .loading-indicator {
    font-size: 12px;
    color: #007bff;
    font-style: italic;
  }
}

.model-generator-history {
  margin-top: 30px;

  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .no-jobs {
    text-align: center;
    color: #999;
    padding: 20px;
    font-size: 14px;
  }

  .job-list {
    .job-item {
      padding: 12px;
      margin-bottom: 7px;
      border: 1px solid #ddd;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s;
      background-color: #fff;

      &:hover {
        border-color: #007bff;
        background-color: #f8f9fa;
      }

      &.active {
        border-color: #007bff;
        background-color: #e7f3ff;
      }

      .job-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;

        .job-title {
          display: flex;
          align-items: center;
          gap: 8px;

          .job-name {
            font-weight: 600;
            font-size: 14px;
          }
        }

        .job-right {
          display: flex;
          align-items: center;
          gap: 6px;

          .job-progress {
            font-size: 12px;
            color: #ffc107;
            font-weight: 600;

            .progress-text {
              font-size: 12px;
            }
          }

          .job-status {
            font-size: 12px;
            padding: 2px 8px;
            border-radius: 3px;
            font-weight: 500;

            &.status-completed {
              background-color: #d4edda;
              color: #155724;
            }

            &.status-failed {
              background-color: #f8d7da;
              color: #721c24;
            }

            &.status-processing {
              background-color: #fff3cd;
              color: #856404;
            }

            &.status-pending {
              background-color: #d1ecf1;
              color: #0c5460;
            }
          }
        }
      }

      .job-meta {
        .job-info-row {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .job-date {
            font-size: 11px;
            color: #666;
          }

          .job-product {
            font-size: 11px;
            color: #666;
          }
        }
      }
    }
  }

  .show-more-btn {
    width: 100%;
    font-size: 13px;
  }
}
</style>
